<template>
  <div>
    <div ref="fotoPortadaRef" class="fotoportada-container">
      <div ref="sparklesContainer" class="sparkles-overlay"></div>

      <div class="overlay">
        <div class="mis-xv-wrapper-fixed">
          <img src="@/assets/corona.png" alt="Ornamento" class="ornamento-img floating">
          <div ref="misXvTopRef" class="mis-xv-top glowing">MIS XV</div>
        </div>

        <div class="centered-text">
          <div ref="apellidoRef" class="nombre-linea">
             <span ref="nombreCamila" class="word">Ana </span>
             <br>
             <span ref="apellidoNunez" class="word">Victoria</span>
          </div>
          
          <div ref="fechaRef" class="fecha-evento">
            <span class="fecha-dia"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-mes"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-anio"></span>
          </div>
        </div>

        <div class="disco-balls-container">
          <img src="@/assets/disco.png" ref="disco1" class="disco-ball ball-1" />
          <img src="@/assets/disco.png" ref="disco2" class="disco-ball ball-2" />
          <img src="@/assets/disco.png" ref="disco3" class="disco-ball ball-3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null);
    const nombreCamila = ref(null);
    const apellidoNunez = ref(null);
    const fechaRef = ref(null);
    const misXvTopRef = ref(null);
    const sparklesContainer = ref(null);
    
    const disco1 = ref(null);
    const disco2 = ref(null);
    const disco3 = ref(null);

    const createSparkle = () => {
      if (!sparklesContainer.value) return;

      let top, left;

      // 🔥 Evitar zona central
      do {
        top = Math.random() * 100;
        left = Math.random() * 100;
      } while (top > 35 && top < 70 && left > 25 && left < 75);

      const sparkle = document.createElement('div');
      sparkle.className = 'sparkle';

      const size = Math.random() * 12 + 4;

      sparkle.style.top = `${top}%`;
      sparkle.style.left = `${left}%`;
      sparkle.style.width = `${size}px`;
      sparkle.style.height = `${size}px`;

      sparklesContainer.value.appendChild(sparkle);

      gsap.fromTo(sparkle, 
        { scale: 0, opacity: 0, rotation: 0 },
        { 
          scale: 1, 
          opacity: 0.8, 
          rotation: 180, 
          duration: 1, 
          yoyo: true, 
          repeat: 1, 
          ease: "power2.inOut",
          onComplete: () => sparkle.remove()
        }
      );
    };

    onMounted(() => {
      setInterval(createSparkle, 120);

      const tl = gsap.timeline();

      tl.from(fotoPortadaRef.value, {
        opacity: 0,
        scale: 1.1,
        duration: 2,
        ease: 'power2.out'
      });

      tl.from(nombreCamila.value, {
        opacity: 0,
        y: -50,
        filter: "blur(10px)",
        duration: 1.5,
        ease: "power4.out"
      }, "-=1");

      tl.from(apellidoNunez.value, {
        opacity: 0,
        y: 50,
        filter: "blur(10px)",
        duration: 1.5,
        ease: "power4.out"
      }, "-=0.8");

      tl.from(misXvTopRef.value, { opacity: 0, y: -20 }, "-=0.5");
      tl.to(fechaRef.value.children, {
        opacity: 1,
        y: 0,
        stagger: 0.2,
        duration: 0.8
      }, "-=0.5");

      tl.from([disco1.value, disco2.value, disco3.value], {
        y: 200,
        opacity: 0,
        stagger: 0.2,
        duration: 1.5,
        ease: "back.out(1.2)"
      }, "-=1");

      [disco1.value, disco2.value, disco3.value].forEach((el, i) => {
        gsap.to(el, {
          y: "-=20",
          rotation: i % 2 === 0 ? 8 : -8,
          duration: 2 + i,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut"
        });
      });
    });

    return {
      fotoPortadaRef, nombreCamila, apellidoNunez, fechaRef,
      misXvTopRef, sparklesContainer, disco1, disco2, disco3
    };
  }
};
</script>

<style scoped>
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-image: 
    linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.5)), 
    url('@/assets/WhatsApp Image 2026-05-26 at 4.33.43 PM(2).webp');
  background-size: cover;
  margin-top:-60px;
  background-position: center;
}

.sparkles-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  pointer-events: none;
  z-index: 2;
}

:deep(.sparkle) {
  position: absolute;
  background: radial-gradient(circle, white 0%, rgba(255,255,255,0) 70%);
  border-radius: 50%;
  filter: blur(1px);
}

.overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

.centered-text {
  text-align: center;
  color: white;
  z-index: 5;
  margin-top: 450px;
}

.word {
  display: inline-block;
  font-family: 'british' !important;
  font-size: 50px;
  padding-top:16px;
  padding-bottom:16px;

  line-height: 1.6;
  background: linear-gradient(to bottom, #ffffff, #e0e0e0);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 10px 20px rgba(0,0,0,0.3);
}

.fecha-evento {
  margin-top: 20px;
  display: flex;
  gap: 10px;
  justify-content: center;
  font-family: 'Karla', sans-serif;
  letter-spacing: 4px;
}

.fecha-evento span { opacity: 0; transform: translateY(10px); }

.disco-balls-container {
  position: absolute;
  bottom: 15%;
  width: 200%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 5%;
  pointer-events: none;
  z-index: 10;
}

.disco-ball {
  width:200px;
  height: auto;
  filter: drop-shadow(0 0 20px rgba(255,255,255,0.5));
}

.ball-1 { width: 0px; opacity: 0.9; }
.ball-2 { width: 0px; }
.ball-3 { width: 0px; opacity: 0.8; }

.mis-xv-wrapper-fixed {
  position: absolute;
  top: 20px;
  left: 20px;
  text-align: center;
}

.ornamento-img {
  width: 40px;
  filter: brightness(0) invert(1);
  opacity: 0.95;
}

.mis-xv-top { font-family: 'file'; font-size: 18px; color: white; }

.glowing {
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from { text-shadow: 0 0 5px #fff; }
  to { text-shadow: 0 0 20px #fff, 0 0 30px #e0e0e0; }
}
</style>